import "./Footer.css";
export default function Footer(){
    return (
        <footer>
            <p>
               © 2026 Neva Mermer. Tüm hakları saklıdır.
            </p>
        </footer>
    );
}